const getPromoColors = (theme: string) => {
    switch (theme) {
        case 'ORANGE':
            return { main: '#E07000', light: 'rgba(255, 178, 102, 0.30)' };
        case 'BLEU':
            return { main: '#007AFF', light: 'rgba(102, 178, 255, 0.3)' };
        default:
            return { main: '#E07000', light: '#ffe8d1' };
    }
};

export default getPromoColors;
